<nav class="c-menu">
  <ul class="c-menu_list">
    <li class="c-menu_list_item" *ngFor="let page of menuList">
      <a class="c-menu_list_link"
         routerLinkActive="c-menu--active"
         [routerLinkActiveOptions]="{ exact: true }"
         [routerLink]="page.link"
         (click)="onMenuClick(page)"
         >{{ page.title }}
        </a>
      </li>
    </ul>
  </nav>
